/**
 * Is all of the element inside the viewport?
 * @param {HTMLElement} el - Element to check
 * @returns All of the element is fully inside the viewport
 */
const isFullyInView = (el) => {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    const vertInView = rect.top >= 0 && rect.bottom <= windowHeight;
    const horInView = rect.left >= 0 && rect.right <= windowWidth;

    return(vertInView && horInView);
};

/**
 * Is any part of the element inside the viewport?
 * @param {HTMLElement} el - Element to check
 * @returns {boolean} - Any part of the element is inside the viewport
 */
const isPartiallyInView = (el) => {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return(vertInView && horInView);
};

/**
 * Is the HTML element inside the viewport?
 * https://gist.github.com/davidtheclark/5515733#gistcomment-2113205
 *
 * @param {HTMLElement} el - Element to check
 * @param {{'partial'|'full'}} portion - Check if element is partially or fully in view
 * @returns {boolean} - Element is inside viewport
 */
export const isInView = (el, portion = 'partial') => {
    return(portion === 'full' ? (
        isFullyInView(el)
    ) : isPartiallyInView(el));
};
